export default {
	index: 'Active season',
	history: 'History',
	account: 'Account',
};
